import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class SellersService {
  getSellersRanking(params) {
    return securedAxiosInstance.get("/sellers/ranking", {
      params: toSnakeCase(params),
    });
  }

  delete(id) {
    return securedAxiosInstance.delete(`/sellers/${id}`);
  }

  update(id, data) {
    return securedAxiosInstance.put(`/sellers/${id}`, toSnakeCase(data));
  }

  fetchIndex(params) {
    return securedAxiosInstance.get("/sellers", { params: toSnakeCase(params) });
  }

  create(params) {
    return securedAxiosInstance.post("/sellers", toSnakeCase(params));
  }
}

export default new SellersService();
